import { Badge } from "reactstrap";
import { H3, Image, P } from "../AbstractElements";
import { Carousel } from "react-responsive-carousel";
import { dynamicImage } from "../Service";

export const Href = "#javascript";

// Header
export const Notification = "Notifications";
export const CheckAll = "Check all";
export const Messages = "Message";
export const Carts = "Cart";
export const OrderTotal = "Order Total";
export const GoToYourCart = "Go to your cart";
export const Checkout = "Checkout";
export const Bookmarks = "Bookmarks";
export const English = "English";
export const Deutsch = "Deutsch";
export const Español = "Español";
export const Français = "Français";
export const Português = "Português";
export const 简体中文 = "简体中文";
export const HelenWalter = "Helen Walter";
export const Admin = "Admin";
export const Back = "Back";
export const AddNewBookmark = "Add New Bookmark";

// Sidebar
export const Pinned = "Pinned";

// Dashboard
export const ShoppingPlaceDashboard = "Shopping place Dashboard";
export const Dashboard = "Dashboard";
export const Default = "Default";
export const TotalEarning = "Total Earning";
export const SinceLastMonth = "Since last month";
export const TotalSales = "Total Sales";
export const ThenLastWeek = "Then last Week";
export const TotalVisitors = "Total Visitors";
export const TopSellers = "Top Seller";
export const Trending = "Trending";
export const JailRoadSylhet = "jail Road,Sylhet";
export const VKEnterprise = "VK Enterprise";
export const SaleImproved = "Sale";
export const  ProductSale = "Product Sale"
export const TopSellingProducts = "Top Selling Product";
export const BluetoothHandphone = "Bluetooth-Handphone";
export const Mamber= "Mamber"
export const WelltechHeadphoneBluetooth =
  "Welltech SH 12 Bluetooth Headphone Bluetooth";
export const Today= "Today"
export const TopCountrie =  "Top Countries"
export const SalesSummarys= "Sales Summary"
export const RecentOrder= "Recent Order"
export const Invoices = "Invoice"
export const ActivityTimelines= "Activity Timeline"
export const TransactionHistorys= "Transaction History"
export const TopCustomers= "Top Customer"
export const SalesAnalyic= "Sales Analyic"
export const DealOpens = "Deal Open"
export const Customers= "Customer"
export const CRMDashboards= "CRM Dashboard"
export const BalanceOverviews ="Balance Overview"
export const Accpet= "Accpet"
export const Decline= "Decline"
export const AllNotifications ="All Notification (4)"
export const Dropdown= "Dropdown"
export const BestFlashSale ="Best Flash Sale"
export const SpecialOffer = "Special Offer"
export const WeekendSale= "Weekend Sale"

// Bonus UI
export const BadgeTitle= "Badge"
export const Scrollables = "Scrollable";
export const CustomScrollbar = "Custom Scrollbar";
export const SmallScrollText = "Solution for Business Transformation";
export const SmallSizeScrollbar = "Small Size Scrollbar";
export const BadgesScrollbar = "Badges Scrollbar";
export const ProfileScrollable = "Profile Scrollable";
export const ScrollableContents = "Scrollable Content";
export const HorizontalScrollbar = "Horizontal Scrollbar";
export const BothSideVisibleScrollbar = "Both Side Visible Scrollbar";
export const Scroll1 = (
  <>
    Inspiration can take many different forms, and{" "}
    <em className="txt-danger">professional growth never stops</em>
    . In light of this, we've compiled a comprehensive list of web design blogs
    that will keep your mind stimulated for the entire year. You won't find any
    stinkers on this list, so don't worry. We value your time and believe that
    you should only receive the greatest. Because of this, we've only gathered
    web design blogs that have recently being updated. Get ready to add numerous
    subscriptions by creating your Feebly account.
    <br />
    --&gt; Responsive...
    <br />
    --&gt; Secure your domain...
    <br />
    --&gt; Testing...
    <br />
    --&gt; Content creation...
    <br />
    --&gt; Visual elements...
    <br />
    --&gt; Launch...
  </>
);
export const Latesttrends = "Latest trends";
export const ThebestUXdesigner = "The best UX designer";
export const Bestwebsiteideas = "How to make best website ideas ";
export const Scroll3 = (
  <>
    <strong>1. Muzli </strong>
    <br />
    <strong>2. Facebook Design </strong>
    <br />
    <strong>3. Awwwards</strong>
    <br />
  </>
);
export const Scroll2 = (
  <>
    --&gt; Blog <br />
    --&gt; Portfolio website <br />
    --&gt; Event website <br />
    --&gt; personal website <br />
    --&gt; Fashion website <br />
    --&gt; Admin dashboards <br />
    --&gt; E-commerce website <br />
    --&gt; Beauty website <br />
    --&gt; Food website
    <br />
    --&gt; Animation website <br />
    --&gt; Financial website
  </>
);
export const TreeViews= "Tree View"
export const BasicTrees= "Basic Tree"
export const DisabledTrees= "Disabled Tree"
export const Toast= "Toasts"
export const LiveToasts= "Live Toast"
export const Toprighttoast = "Top-right toast"
export const ColorsScheme= "Colors Schemes"
export const StackingToast = "Stacking Toasts"
export const TranslucentToast= "Translucent Toasts"
export const DefaultToasts= "Default Toast"
export const UniqueToasts= "Unique Toast"
export const Bottomrighttoast= "Bottom-right toast"
export const BottomrighttoastDetails="Your time over after 5 minute."
export const Toplefttoast= "Top-left toast"
export const CionTheme= "Cion Theme"
export const Bottomlefttoast= "Bottom-left toast"
export const RemoveMyAccount= "Remove My Account"
export const ToastBody1="Your account will be permanently deleted?"
export const Kohotheme= "Koho theme"
export const Fastkarttheme= "Fastkart theme"
export const Oslotheme= "Oslo theme"
export const Voxotheme= "Voxo theme"
export const Roxotheme= "Roxo theme"
export const Zetatheme= "Zeta theme"
export const ToastPlacements = "Toast Placement"
export const ToastContent = (
  <>
<em className="txt-danger">Attackers</em> on malicious activity
may trick you into doing something dangrous like installing
software or revealing your personal informations.
</>
)
export const Ratings = "Rating"
export const Rating10 = "1/10 Rating";
export const RatingBars = "1 To 10 Rating Bar"
export const StarRatingBar = "Star Rating Bar";
export const ReversedRatingBar = "Reversed Rating Bar"
export const ThumbUpDownRate = "Thumb Up/Down Rating";
export const RatingWithTooltip = "Rating With Tooltip";
export const FontawesomeThumbsUpDownRating = "Fontawesome Thumbs Up/Down rating";
export const CurrentRatingBar = "Current Rating Bar";
export const WilliamEmail = "William@jourrapide.com";
export const January = "02 January 1988";
export const BOD = "BOD";
export const Dropzones = "Dropzone"
export const DefaultFileUpload= "Default File Upload"
export const ImagePreviews= "Image Preview"
export const SingleFileUploads= "Single File Upload"
export const MultiFileUploads= "Multi File Upload"
export const Tours= "Tour"
export const Selectposition= "Select a position..."
export const NewProducts= "New Product"
export const Name = "Name"
export const Code = "Code"
export const Price = "price"




// Ui-kits
export const Typographys= "Typography"
export const UiKits= "Ui Kits"
export const Heading= "Headings"
export const FontSize= "Font-Size"
export const Heading1 = "Heading 1 (MEGA)"
export const Heading2= "Heading 2 (XL)"
export const Heading3= "Heading 3 (LARGE)"
export const Heading4 = "Heading 4 (MEDIUM)"
export const Heading5= "Heading 5 (SMALL)"
export const Heading6= "Heading 6"
export const ColoredHeading= "Colored Headings"
export const SubHeading = " Sub Heading";
export const Fw700 = "f-w-700";
export const Fw600 = "f-w-600";
export const Fw500 = "f-w-500";
export const Fw400 = "f-w-400";
export const Fw300 = "f-w-300";
export const Unorder_list = "Unorder list";
export const Order_list = "Order list";
export const BonusUi = "Bonus Ui";
export const Animations = "Animations";
export const Typography = "Typography";
export const Avatar = "Avatars";
export const Grid = "Grid";
export const Tagpills = "Tag & pills";
export const Dropdowns = "Dropdown";
export const Tabs = "Tabs";
export const Accordion = "Accordion";
export const Display = "Display";
export const Displayheadings = "display heading";
export const Displayheading = "Display heading";
export const Additive_Border = "Additive Border";
export const Subtractive_Border = "Subtractive Border";
export const Additive_Radius = "Additive Radius";
export const CustomBorder_radius = "Custom Border-radius Class";
export const Border_Color = "Border Color";
export const Border_Width = "Border-Width";
export const Text_Colors = "Text Colors";
export const Dark_Background = "Dark Background";
export const Light_Backgrounds = "Light Backgrounds";
export const Light_Background = "Light Background";
export const Extended_Background = "Extended Background Colors";
export const Light_card = ".light-card";
export const Inlinetextelements = "Inline text elements";
export const Sizes = "Sizes"
export const StatusIndicator= "Status Indicator"
export const Shapes= "Shapes"
export const Ratio= "Ratio"
export const Grouping= "Grouping"
export const HelpersClasses= "Helper Classes"
export const StylesInBorders= "Styles In Borders"
export const BordersAndDisplays= "Borders And Displays"
export const BackgroundColors= "Background Colors"
export const TextColor= "Text Colors"
export const FontsSizes= "Font Sizes"
export const Grids = "Grid"
export const Gridbehavior = "Grid behavior";
export const Horizontaltimes = "Horizontal at all times";
export const Collapsedtostart =
  "Collapsed to start, horizontal above breakpoints";
export const Maxcontainerwidth = "Max container width";
export const None = "None (auto)";
export const Px540 = "540px";
export const Px720 = "720px";
export const Px960 = "960px";
export const Px1140 = "1140px";
export const Px1320 = "1320px";
export const Classprefix = "Class prefix";
export const Cols = ".col-";
export const Colsm = ".col-sm-";
export const Colmd = ".col-md-";
export const Collg = ".col-lg-";
export const Colxl = ".col-xl-";
export const Colxxl = ".col-xxl-";
export const Ofcolumns = "# of columns";
export const Gutterwidth = "Gutter width";
export const Gutterwidthno = "1.5rem (.75rem on left and right)";
export const Nestable = "Nestable";
export const Yes = "Yes";
export const Offsets = "Offsets";
export const Columnordering = "Column ordering";
export const Onecolumns = "one column";
export const Onecolumn = "One column";
export const Twocolumns = "two column";
export const Twocolumn = "Two column";
export const GridOption= "Grid Options"
export const GridForColumn= "Grid For Column"
export const Class = "Class";
export const Valueclass = "Value of the class";
export const Verticalclass = ".align-items-*";
export const VerticalPosition =
  " start / center / end / baseline / stretch";
export const HorizontalClass = ".justify-content-*";
export const HorizontalPosition =
  "start / ce end / around / between";
export const Level1col3 = "Level 1: .col-3";
export const Level2col5 = "Level 2: .col-5";
export const Level2col7 = "Level 2: .col-7";
export const Level1col2 = "Level 1: .col-2";
export const Level1col10 = "Level 1: .col-10";
export const Level2col4 = "Level 2: .col-4";
export const Orders = "Order"
export const OrderClass = ".order-*";
export const OrderPosition = " first / 2 / 3 / 4 / 5 / last";
export const OffsetClass = ".offset-*";
export const OffsetStep = " 1 / 2 / ... / 11 / 12";
export const HorizontalAlignments = "Horizontal Alignment"
export const Nestings= "Nesting"
export const VerticalAlignments= "Vertical Alignment"
export const ImagesSizes="Images Sizes"
export const BorderColor = "Border Color"
export const Blockquotes= "Blockquotes"
export const ListingTypographys= "Listing Typography"
export const TextColors= "Text Color"
export const FontWeights= "Font Weight"
export const BadgesContextual = "Badges Contextual Variations";
export const PillsVariations = "Pills Contextual Variations";
export const NumberofBadge = "Number of Badge";
export const NumberofPills = "Number of Pills Tags";
export const BadgeIcons = "Badge Tags With Icons";
export const PillsWithIcons = "Rounded Pills With Icons";
export const BadgeHeadingsExample = "Badge Headings Example";
export const BadgeHeadings = "Badge Heading";
export const Latest = "Latest";
export const Logout = "Logout";
export const BadgesPartButtons = "Badges As Part Buttons";
export const Login = "Log in";
export const Inbox = "Inbox";
export const Primary= "Primary"
export const Message= "Messages"
export const Charts = "Chart"
export const MonthlyHistorys= "Monthly History"
export const SkillStatuss= "Skill Status"
export const OrdersStatus = "Order Status"
export const LiveProduct= "Live Products"
export const TurnOver= "Turn over"
export const CryptoAnnotation= "Crypto Annotations"
export const CryptocurrencyPrice= "Cryptocurrency Prices"
export const StockMarkets= "Stock Market"
export const Finances= "Finance"
export const MonthlySale= "Monthly Sales"
export const Uses= "Uses"
export const BasicProgressBars = "Basic Progress Bars";
export const ProgressStriped = "Progress Bars Striped";
export const Progressanimated = "Progress Bars animated";
export const Simple = "Simple";
export const Upto = "Up to ";
export const SimpleText = ", Hurry Up Online Shopping";
export const ExploreMore = "Explore More";
export const Close = "Close";
export const SaveChanges = "Save Changes";
export const Scrollingcontent = "Scrolling content";
export const WedDesigner = "Wed Designer";
export const Multiplebars= "Multiple bars"
export const ProgressWithNumberSteps= "Progress With Number Steps"
export const CustomProgressBars = "Custom Progress Bars"
export const SmallProgressBars= "Small Progress Bars"
export const LargeProgressBars= "Large Progress Bars"
export const CustomHeightProgressBars= "Custom Height Progress Bars"
export const Alerts = "Alert"
export const LinkColorInDarkTheme= "Link Color In Dark Theme"
export const PrimaryAlert = "Primary Alert"
export const PrimaryLightAlert = "Primary Light Alert"
export const LinkColorInLightTheme= "Link Color In Light Theme"
export const OutlineDarkAndLightAlerts= "Outline Dark And Light Alerts"
export const AlertsWithIconsandTextActions= "Alerts With Icons and Text Actions"
export const Check = "Check";
export const Showlivealert = "Show live alert";
export const DismissingDarkAlerts= "Dismissing Dark Alerts"
export const DismissingLightAlerts = "Dismissing Light Alerts"
export const LiveAlerts= "Live Alert"
export const LeftBorderAlerts= "Left Border Alert"
export const AdditionalContent= "Additional content"
export const Modals= "Modal"
export const BasicModals= "Basic Modal"
export const Tooltipspopovers = "Tooltips and popovers";
export const Popovermodal = "Popover in a modal";
export const This = "This ";
export const TriggerText = " triggers a popover on click.";
export const Thislink = "This link";
export const And = "and";
export const Thatlink = "that link";
export const HoverText = " have tooltips on hover.";
export const Tooltipsmodal = "Tooltips in a modal";
export const OpenmodalforCion = "Open modal for Cion";
export const HurryUp = "Hurry Up!";
export const CionSIGNUP = "CION SIGN-UP";
export const FirstName = "First name";
export const Lastname = "Last name";
export const Checktext =
  "You accept our Terms and Privacy Policy by clicking Submit below.";
  export const TooltipButtontext = "this is amazing content";
  export const SignUp = "Sign Up";
export const Looksgood = "Looks good!";
export const SizesModals = "Sizes Modal"
export const FullScreenModal = "Full Screen Modal";
export const Fullscreenmodal = "Fullscreen modal";
export const ExtraLargeModal = "Extra large Modal";
export const Large_Modal = "large Modal";
export const Small_Modal = "Small Modal";
export const Startyourgoals = "Start with your goals";
export const WebDesign = "Web Design";
export const Fullscreenbelow_sm = "Fullscreen below sm";
export const Fullscreenbelow_md = "Fullscreen below md";
export const Fullscreenbelow_lg = "Fullscreen below lg";
export const Fullscreenbelow_xl = "Fullscreen below xl";
export const Fullscreenbelow_xxl = "Fullscreen below xxl";
export const Verticallycentered = "Vertically centered";
export const CenteredError = "Ohh! Something went wrong!";
export const Openfirstmodal = "Open first modal";
export const RemoveaccountText =
  "Remove your complete account from your phone or tablet to sign out of the Gmail app.";
export const Connectnewaccount = "Connect new account";
export const Cancel = "Cancel";
export const Notamember = " Not a member?";
export const Register = "Register";
export const YesLogout = "Yes, Log out";
export const LogoutText = "Are you sure want to logout this dashboard?";
export const Alreadyleaving = "Already leaving??";
export const Staticbackdropmodal = "Static backdrop modal";
export const FullscreenModals= "Fullscreen Modal"
export const CenteredModals= "Centered Modal"
export const ToggleBetweenModals= "Toggle Between Modals"
export const StaticBackdropModal= "Static Backdrop Modal"
export const CionLogin = "Cion Login";
export const Email = "Email";
export const Password = "Password";
export const Checkmeout = "Check me out";
export const Signin = "Sign in";
export const ClickOut = "Click Out";
export const CionCustomModals= "Cion Custom Modals"
export const Modal_1 = "Modal 1 - ";
export const Modal_2 = "Modal 2 - ";
export const Modal_3 = "Modal 3 - ";
export const ResultModal = "Result Modal";
export const WilliamJennings = "William C. Jennings";
export const ContactUs = "Contact Us";
export const Contactno = "US 310-273-0666";
export const LibbyStreet = "4377 Libby Street Beverly Hills";
export const Follower = "Follower";
export const Following = "Following";
export const Jan25 = "25 Jan";
export const Minread6 = "6 min read";
export const min3ago = "3 min ago";
export const min1read = "1 min read";
export const hours10ago = "10 hours ago";
export const ProfileHead2 =
  "Wonderful piece that successfully conveys the magnificence of the mountains and the natural world.";
export const ProfileHead2Text = (
  <>
    English Romantic painter, printer, and watercolourist{" "}
    <em className="txt-danger">William C. Jennings</em>{" "}
    {
      "Is most renowned for his expressive colorization, creative landscapes, and stormy, sometimes violent maritime works. However, this moody image of the Devil's Bridge in Switzerland, close to the Gotthard Pass, feels incredibly authentic and accurately depicts historical occasions when Russian general Suvorov crossed the Alps and fought not only far larger enemy troops!"
    }
  </>
);

export const ProfileText2 = (
  <>
    {
      "The curved canvas is enclosed in a complex frame that the artist created but that his buddy Gottlieb Christian Kuhn carved. A variety of Christian symbols are depicted on the frame, including the faces of five infant angels, a star, grapes, vines, corn, and God's eye.Many of the Romantic elements and subjects that he would explore throughout his career are present in this work, one of his earliest, most notable of which is the landscape's significant significance. In spite of the altarpiece's inclusion of a crucifix, the emphasis is"
    }
    <a className="txt-danger" href="user-profile.html" target="_blank">
      {" "}
      Read More
    </a>
  </>
);
  export const Location= "Location"
  export const Dec09 = "09 Dec";
export const Min2read = "2 min read";
export const Clickit = "Click it!";
export const Surprise = "Surprise!";
export const Informational = "Informational";
export const Warning = "Warning";
export const Pikachu = "Pikachu";
export const Questionsstate = "Questions state";
export const Username = "Username";
export const Loginsuccessfully = "Login successfully";
export const Dangermode = "Danger mode";
export const Alertmode = "Alert mode";
export const Timer = "Timer";
export const Moviemode = "Movie mode";
export const Copytext = "Copy text";
export const Breadcrumbs = "Breadcrumb";
export const DefaultBreadcrumbs = "Default Breadcrumb";
export const UIKits = "UI Kits";
export const Alert = "Alert";
export const DividerBreadcrumb = "Divider Breadcrumb";
export const Progress = "Progress";
export const WithIconsBreadcrumb = "With Icons Breadcrumb";
export const VariationOfBreadcrumb = "Variation Of Breadcrumb";
export const Homegt = "Home ->";
export const Tablesgt = "Tables ->";
export const Bootstrapgt = "Bootstrap Tables ->";
export const BasicTables = "Basic Tables";
export const ColoredBreadcrumb = "Colored Breadcrumb";
export const Flag_icon = "Flag-icon";
export const Gallery = "Gallery";
export const Gallery_grid = "Gallery-grid";
export const RangeSliders = "Range Slider";
export const BasicSlider = "Basic Slider";
export const NegativeValues = "Negative Values";
export const Disabled = "Disabled";
export const FormatedLabel = "Formated Label";
export const DraggableRange = "Draggable Range";
export const ImageCroppers = "Image Cropper";
export const BasicCards = "Basic Card";
export const BasicCardText = (
  <>
    Tabs have long been used to show alternative views of the same group of
    information tabs in software. Known as
    <em className="txt-danger">“module tabs”</em> , these are still used today
    in web sites. For instance, airline companies such as Ryanair, easyJet and
    AirMalta use module tabs to enable the user to switch between bookings for
    flights, hotels and car hire.
  </>
);
export const FlatCards = "Flat Card";
export const FlatCardText = (
  <>
    A navigation bar is a particularly important feature because it allows
    visitors to quickly and easily find
    <em className="txt-danger"> important pages on your website</em> , like your
    blog, product pages, pricing, contact info, and documentation. This improves
    the chances of visitors browsing your site longer, which can boost your page
    views and reduce your bounce rate.
  </>
);
export const WithoutshadowCard = "Without shadow Card";
export const ShadowCardText = (
  <>
    {" "}
    <strong>Visit Us: </strong> 2600 Hollywood Blvd,Florida, United States-
    33020
    <br />
    <strong>Mail Us:</strong>contact@us@gmail.com
    <br />
    <strong>Contact Number: </strong>(954) 357-7760
  </>
);
export const IconInHeading = " Icon In Heading";
export const IconHeadtext = (
  <>
    Use the any icons for heading. <code>[font-awesome/ico-font/feather]</code>.
  </>
);
export const IconHeadtext2 = (
  <>
    <P className="mb-xl-0 mb-sm-4">
      We provide end to end digital solutions, right from designing your
      website/application development: Domain, Web Hosting, Email Hosting
      Registration, Search Engine Optimization and other Internet Marketing,
      Renewal of Services timely and effectively.
    </P>
  </>
);
export const DarkColorCard = "Dark Color Card";
export const DarkHeadtext = (
  <>
    Use the <code>.bg-dark </code>color for dark background card.
  </>
);
export const DarkBodytext = (
  <>
    <P>
      {" "}
      <em className="txt-danger fw-bold">Smart headphones</em> — also called
      smart earbuds or hearable — are high-tech in-ear devices that do more than
      transmit audio. These headphones are usually wireless, and they can sync
      up with your phone, tablet, computer or other Bluetooth-enabled device.
      The main appeal of hearables is convenience, as they allow you to complete
      common tasks without directly accessing your phone or computer. Smart
      wireless headphones sync up to other devices using Bluetooth technology,
      and many of their features rely on data from your smartphone or computer.
    </P>
  </>
);
export const Card_Footer = "Card Footer";
export const InfoColorHeader = "Info Color Header";
export const InfoHeadText =
  "By following instructions and adding your own unique twist and style, you may apply your imagination as a web designer. The majority of the tasks you'll be assigned will have a specific due date and work description, but the reason you were employed was because they need a specialist to inject some much-needed creativity.";
export const CubaTheme = "Cuba Theme";
export const InfoColorBody = "Info Color Body";
export const InfoBodyText =
  'It is the responsibility of the UX designer to make a product or service useful, pleasurable, and accessible. The word "user experience" is used by various industries, although it is most frequently related to digital design for websites and mobile applications.There is no need for coding in user experience design.';
export const InfoFooter = "Info Color Footer";
export const WebDeveloper = "Web Developer";
export const FooterInfotext =
  "A programmer who uses the client-server architecture to create World Wide Web applications is known as a web developer. The apps generally employ any general-purpose programming language on the server and HTML, CSS, and JavaScript on the client.";
export const UXDesigner = "UX Designer";
export const Oneof = "One of ";
export const InfoColorBodys = "Info Color Body";
export const CreativeCards = "Creative Card";
export const BorderLefts = "Border Left";
export const BorderleftText =
  "Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them.";
export const VisitUs= "Visit Us:"
export const MailUs= "Mail Us:"
export const ContactNumber= "Contact Number:"
export const BorderRights= "Border Right"
export const BorderRightText =
  "Us Technology offers web & mobile development solutions for all industry verticals.Include a short form using fields that'll help your business understand who's contacting them. ";
export const BorderTopText= (
  <>
    Tabs have long been used to show alternative views of the same group of
    information tabs in software. Known as
    <em className="txt-danger">“module tabs”</em> , these are still used today
    in web sites. For instance, airline companies such as Ryanair, easyJet and
    AirMalta use module tabs to enable the user to switch between bookings for
    flights, hotels and car hire.
  </>
);
export const Emailaddress = "Email address";
export const BorderTops= "Border Top"
export const BorderBottoms= "Border Bottom"
export const BorderBottomText = (
  <>
    A navigation bar is a particularly important feature because it allows
    visitors to quickly and easily find
    <em className="txt-danger"> important pages on your website</em> , like your
    blog, product pages, pricing, contact info, and documentation. This improves
    the chances of visitors browsing your site longer, which can boost your page
    views and reduce your bounce rate.
  </>
);
export const SimpleAccordionText = (
  <P>
    {" "}
    Web design<em className="txt-danger"> identifies the goals</em> of a website
    or webpage and promotes accessibility for all potential users. This process
    involves organizing content and images across a series of pages and
    integrating applications and other interactive elements{" "}
  </P>
);
export const SimpleAccordionText1 = (
  <P>
    {" "}
    <strong> Search engine optimization: </strong> Search engine optimization
    (SEO) is a method for improving the chances for a website to be found by
    search engines. Web design codes information in a way that search engines
    can read it. It can boost business because the site shows up on the top
    search result pages, helping people to find it.
    <br />
    <br />
    <strong> Mobile responsiveness:</strong> Mobile responsiveness is the
    feature of a website that allows it to display on a mobile device and adapt
    its layout and proportions to be legible. Web design ensures sites are easy
    to view and navigate from mobile devices. When a website is well-designed
    and mobile-responsive, customers can reach the business with ease.
    <br />
    <br />
    <strong> Improved sales:</strong>Increasing the number of items sold or
    acquiring more active customers are objectives of a compelling website. As
    web design reaches targeted customers and search engines, it helps the
    business make conversions on their site and improve its sales.
  </P>
);
export const SimpleAccordionText2 = (
  <P>
    {" "}
    The web design process allows designers to adjust to any preferences and
    provide effective solutions. There are many standard components of every web
    design, including:
    <br />
    --&gt; Layout
    <br />
    --&gt; Images
    <br />
    --&gt; Visual hierarchy
    <br />
    --&gt; Color scheme
    <br />
    --&gt; Typography
    <br />
    --&gt; Navigation
    <br />
    --&gt; Readability
    <br />
    --&gt; Content
  </P>
);
export const BorderPrimaryState = "Border Primary State"
export const TeresaMosteller = "Teresa J. Mosteller";
export const GloriaAcheson = "Gloria D. Acheson";
export const BryanOwens = "Bryan A. Owens";
export const BorderWarningState= "Border Warning State"
export const BorderWarningtext =
  "known for delivery of useful and usable solutions";
export const BorderWarningtext1 = "Solve your problem with us";
export const BorderWarningtext2 = "Certified Professionals";
export const BorderWarningtext3 = "Growth-Driven ";
export const BorderSecondaryState= "Border Secondary State"
export const StellaNowland = "Stella Nowland ";
export const LolaStanford = "Lola Stanford ";
export const CaitlinCoungeau = "Caitlin Coungeau ";
export const GracielaMcClaran = "Graciela McClaran ";
export const Freelance = "Freelance ";
export const Issue = "Issue ";
export const Social = "Social ";
export const AbsoluteCard = "Absolute Card";
export const AbsolutePrimarytext =
  "We provide end to end digital solutions, right from designing your website/application development: Domain, Web Hosting, Email Hosting Registration, Search Engine Optimization and other Internet Marketing, Renewal of Services timely and effectively.";
export const AbsoluteSecondarytext =
  "When someone visits your homepage, your design should inspire them to stay. Therefore, your value proposition should be established on the homepage for visitors to select to stay on your website.Building trust, expressing value,to the next step all depend on a page's design.";
export const TimeLines= "TimeLine"
export const BasicTimeline= "Basic Timeline"
export const HoveringTimeline= "Hovering Timeline"
export const Hover1text = "January 2022- Annual Function";
export const Hover1text2 = "Largo Febo,10225012-Calvisano BS";
export const Locationtext =
  "What a dynamic performance by the eighth-grade students, Let's welcome the ninth-grade kid to the stage.";
export const MollyBoake = "Molly Boake";
export const Mollymail = "MollyBoake@rhyta.com";
export const Ofwrrior = "Ofwrrior Company";
export const FresherTime = "March 2022 - Fresher Interview";
export const USMeeting = "US Meeting";
export const LillianGoodfellow = "Lillian J. Goodfellow";
export const CarolynSutton = "Carolyn A. Sutton";
export const UpdatedProduct = "Updated Product";
export const Updatetext = "Quisque a consequat ante sit amet magna...";
export const AddedBewItems = "Added Bew Items";
export const Afresher = "A fresher's interview is to be conducted";
export const VariationTimelines= "Variation Timeline"
export const Tellojust = "Tello just like your product";
export const HorizontalTimelines = "Horizontal Timeline"
export const Conference_util = "Conference";
export const Meeting_util = "Meeting";
export const Readmore = "Read more";
export const Meet_up = "Meet-up";
export const Launch_Theme = "Launch Theme";
export const TimeLineData1 =
    <div className="cd-timeline-content">
        <div className="timeline-wrapper">
            <Badge color="warning">app-ideas</Badge>
        </div>
        <H3 className="m-0">Established new the app-ideas repository.</H3>
        <P className="mb-0">
            developers who are just beginning their learning process. those who often concentrate on developing programmes with a user interface.</P>
        <div className="time-content pt-2">
            <i className="icon-github" />
            <H3>View it on Github</H3>
        </div>
    </div>

export const TimeLineData2 =
<div className="cd-timeline-content">
    <div className="timeline-wrapper">
        <Badge color="danger">Blog</Badge>
    </div>
    <H3 className="m-0">Implemented the program for weekly code challenges.</H3>
    <P className="mb-0">
        Challenges <em className="txt-danger">help you build problem-solving skills, better understand the programming. </em>If you want to improve your skills in programming.         </P>
    <div className="ratio ratio-21x9 m-t-20">
        <iframe src="https://www.youtube.com/embed/sqRk0Ly66Ps" allowFullScreen title="abc"/>
    </div>
</div>
export const TimeLineData3 =
<div className="cd-timeline-content">
    <div className="timeline-wrapper">
      <Badge color="info">Designer</Badge>
    </div>
    <H3 className="m-0">Research about most recent design trends.</H3>
    <P className="mb-0">Spend some time looking up current design trend.</P>
    <Carousel>
      <div>
        <Image className="d-block w-100" src={dynamicImage("banner/1.jpg")} alt="office-work" />
      </div>
      <div>
        <Image className="d-block w-100" src={dynamicImage("banner/2.jpg")} alt="office-work" />
      </div>
      <div>
        <Image className="d-block w-100" src={dynamicImage("banner/3.jpg")} alt="office-work" />
      </div>
    </Carousel>
</div>

export const TimeLineData4 =
    <div className="cd-timeline-content">
        <div className="timeline-wrapper">
            <Badge color="primary">Audio testing</Badge>
        </div>
        <H3 className="m-0">Musical trends and predictability</H3>
        <P className="mb-0">So, the next time you listen to music, you might or might not consider how it's actively altering your mood.</P>
        <audio controls>
            <source src="../assets/audio/horse.ogg" type="audio/ogg" />
        </audio>
    </div>
export const TimeLineData5 =
<div className="cd-timeline-content">
    <div className="timeline-wrapper">
        <Badge color="success">Meet-up</Badge>
    </div>
    <H3 className="m-0">{"Web-designer's meet-up"}</H3>
    <P className="mb-0"> {"Find nearby web designers to network with! A Web Design Meetup is a place where you can discuss tools."}</P>
    <div className="time-content pt-2"><i className="icon-android" />
        <H3>Please! Meet-up</H3>
    </div>
</div>
export const TimeLineData6 =
<div className="cd-timeline-content">
    <div className="timeline-wrapper">
        <Badge color="warning" >Resolutions</Badge>
    </div>
    <H3 className="m-0">My Resolutions for 2023</H3>
    <P className="mb-0">{"I'm determined to streamline, organism, systematism, realign, and embrace life in 2023."}</P>
    <div className="time-content pt-2"><i className="icon-write" />
        <H3>My Resolutions</H3>
    </div>
</div>
export const OwlCarousels= "Owl Carousel"
export const SlidesOnly= "Slides Only"
export const WithControls= "With Controls"
export const AutoPlayVariant= "Auto Play Variant"
export const WithIndicators= "With Indicators"
export const IndividualCarousels= "Individual Carousel-Item Interval"
export const VerticalCarousels= "Vertical Carousel"
export const WithCaptions= "With Captions"
export const CenterSlides = "Center Slide"
export const SweetAlerts= "Sweet Alert"
export const BasicExample= "Basic Example"
export const TitleWithATextUnder= "Title With A Text Under"
export const InfoAlerts= "Info Alert"
export const WarningAlerts= "Warning Alert"
export const PikachuAlert= "Pikachu Alert"
export const QuestionsAlert= "Questions Alert"
export const UsernameAlert= "Username Alert"
export const SuccessMessages= "Success Message"
export const DangerAlerts= "Danger Alert"
export const WarningModal= "Warning Modal"
export const AutoCloseTimer= "Auto Close Timer"
export const AJAXRequestMovie= "AJAX Request Movie"
export const Ribbon= "Ribbons"
export const VariationsOfLeftRibbons= "Variations Of Left Ribbons"
export const VariationsOfRightRibbons  = "Variations Of Right Ribbons"
export const Pagination= "Paginations"
export const DefaultPaginations= "Default Pagination"
export const PaginationWithActiveAndDisabled = "Pagination With Active And Disabled"
export const PaginationWithIcons= "Pagination With Icons"
export const RoundedPaginations= "Rounded Pagination"
export const PaginationAlignment = "Pagination Alignment"
export const PaginationSizing= "Pagination Sizing"
export const ProfileModal = "Profile Modal";
export const BalanceModal = "Balance Modal";
export const ResultText = "Example of Cion login form.";
export const BrooklynSimmons = "Brooklyn Simmons";
export const Brooklysimmons = "@brookly.simmons";
export const YourBalance = "Your Balance";
export const YourTotalBalance = '768,987.90';
export const Cash_Back = "Cash Back";
export const Investment_Constant = "Investment";
export const Popoverontop = "Popover on top";
export const Popovers= "Popover"
export const BasicPopover= "Basic Popover"
export const Popovertitle= "Popover title"
export const HoverPopover= "Hover Popover"
export const Hovertooltip= "Hover tooltip"
export const Dismissiblepopover = "Dismissible popover"
export const PopoverDirections= "Popover Direction"
export const PopoverOnTop= "Popover On Top"
export const PopoverOffset= "Popover Offset"
export const Popoveroffset = "Popover offset 50"
export const Popoversoffset= "Popover offset -50"
export const PopoverOnLeft= "Popover On Left"
export const Tooltips= "Tooltip"
export const BasicTooltips = "Basic Tooltip"
export const BasicTooltipText = "It's magic please hover me... ";
export const SurpriseText = "Surprise!!! Thank you for hovering...";
export const InlineTooltipContent = "Inline Tooltip Content";
export const Toolstip = "tooltip";
export const ColoredTooltips= "Colored Tooltip"
export const TooltipDirections= "Tooltip Directions"
export const Tooltipontop ="Tooltip on top"
export const HTMLElementsWithHoverEffect= "HTML Elements With Hover Effect"
export const NotificationsReceived= "Notifications Received"
export const FilledTooltip= "Filled Tooltip"
export const TooltipPrimary = "Tooltip Primary"
export const HtmlTooltipData2="<b>Thank</b> <em>you</em>"
export const HtmlTooltipData3="<em>Thank</em> <u>you</u>"
export const HtmlTooltipData4="<b>Thank</b> <em>you</em>"
export const BasicDropdowns = "Basic Dropdown"
export const Project= "Project"
export const ProjectProgress = 'Project Progress';
export const ProjectProgressPlaceholder = "Enter project Progress"
export const Ecommerce= "Ecommerce"
export const Crypto= "Crypto"
export const RoundedDropdowns = "Rounded Dropdown"
export const Dark = "Dark";
export const Light = "Light";
export const Lighter = "Lighter";
export const General = "General";
export const Chart = "Chart";
export const Party = "Party";
export const PartyList = "Party List";
export const Balloons = "Balloons";
export const SplitDropdowns = "Split Dropdown"
export const HeadingDropdowns = "Heading Dropdown"
export const Cake= "Cake"
export const WithInputType= "With Input Type"
export const Defaultcheckbox = "Default checkbox";
export const Defaultradio = "Default radio";
export const DarkNight = "Dark Night";
export const Darkmoon = "Dark moon";
export const Darkowl = "Dark owl";
export const Nightfall = "Nightfall";
export const Dropdownform = "Dropdown form";
export const Rememberme = "Remember me";
export const Text = "Text";
export const Hourly = 'Hourly';
export const FixPrice = 'Fix price';
export const Textleft = "Text-left";
export const Priority = 'Priority';
export const PriorityPlaceholder ="Select Status"
export const Low = 'Low';
export const ProjectSizePlaceholder ="Select Issues"
export const High = 'High';
export const EndingDate ="Ending date"
export const Urgent = 'Urgent';
export const Hello = "Hello..";
export const Howareyou = "How are you?";
export const Whatareyou = "What are you doing?";
export const Warningtop = "Warning top";
export const Becareful = "Be careful ";
export const Notifications = "Notifications";
export const Beware = "Beware ";
export const Largebutton = "Large button";
export const Smallbutton = "Small button";
export const Mediumbutton = "Medium button";
export const VeryLargebutton = "Very Large button";
export const VerySmallbutton = "Very Small button";
export const ExtraSmallbutton = "Extra Small button";
export const Extraextrasmall = "Extra Extra small";
export const DarkDropdowns= "Dark Dropdown"
export const UniqueDropdowns= "Unique Dropdown"
export const JustifyContents= "Justify Contents"
export const Alignments= "Alignments"
export const HelperCards= "Helper Card"
export const DividerDropdowns= "Divider Dropdown"
export const DropdownSizings= "Dropdown Sizing"
export const Accordions= "Accordion"
export const UploadProjectFiles = 'Upload project file';
export const DropFilesHereOrClickToUpload = "Drop files here or click to upload.";
export const DropFileUploadText = '(This is just a demo dropzone. Selected files are ';
export const ActualFileUpload = ' actually uploaded.)';
export const SimpleAccordions= "Simple Accordion"
export const Webdesignersdo = "What do web designers do?";
export const Usewebdesign = "What is the use of web design?";
export const Elementswebdesign = "What are the elements of web design?";
export const FlushAccordions = "Flush Accordion" 
export const MultipleCollapseAccordion = "Multiple Collapse Accordion"
export const Togglefirst = "Toggle first element";
export const Togglesecond = "Toggle second element";
export const Toggleboth = "Toggle both elements";
export const Togglewidthcollapse = "Toggle width collapse";
export const Linkwithhref = "Link with event";
export const ButtonwithEvent = "Button with event";
export const WithIconsAccordion= "With Icons Accordion"
export const OutlineAccordions ="Outline Accordion"
export const HorizontalAccordions= "Horizontal Accordion"
export const CollapseAccordions= "Collapse Accordion"
export const BootstrapTabs= "Bootstrap Tabs"
export const Simpletabs= "Simple tabs"
export const Profile = "Profile";
export const Tables = "Tables";
export const Contact = "Contact";
export const Home = "Home";
export const IconsWithTabs = "Icons With Tabs"
export const VerticalTabs= "Vertical Tabs"
export const Components = "Components";
export const Settings = "Settings";
export const Pages = "Pages";
export const Aboutus = "About us";
export const Contactus = "Contact us";
export const Blog = "Blog";
export const Pillstabs= "Pills tabs"
export const JustifyTabs = "Justify Tabs"
export const CionProfile = "CION Profiles For New Employees:";
export const Webdesigner = "Web designer";
export const WebDesigner = "Web Designer";
export const UXdesigner = "UX designer";
export const IOTdeveloper = "IOT developer";
export const MaterialStyleLeftTabs= "Material Style Left Tabs"
export const MaterialStyleTabs = "Material Style Tabs"
export const User = "User";
export const Description = "Description";
export const Review = "Review";
export const LogoDesign = "Logo Design";
export const Web_Design = "Web Design & Development ";
export const ECommerce = "E-Commerce";
export const SEO = "SEO";
export const WowAnimations = "Wow Animations";
export const ApexCharts = "Apex Charts";
export const StarterKits = "Starter Kits";
export const PRODUCT = "PRODUCT";
export const PRODUCTDETAILS = "PRODUCT DETAILS ";
export const CART = "CART ";
export const CHECKOUT = "CHECKOUT";
export const BorderTab = "Border Tabs"

// MISCELLANEOUS
export const SamplePages= "Sample Page"
export const GalleryGrids=  "Gallery Grid"
export const IMAGEGALLERY = "IMAGE GALLERY";
export const GalleryGridWithDescriptions = "Gallery Grid With Description"
export const IMAGEGALLERYWITHDESCRIPTION  ="IMAGE GALLERY WITH DESCRIPTION"
export const MasonryGallerys= "Masonry Gallery"
export const MasonryGalleryWithDescriptions= "Masonry Gallery With Description"
export const PortfolioTitle = "Portfolio Title";
export const ImageHoverEffect= "Image Hover Effects"
export const HoverEffect= "Hover Effects"
export const BlogDetail= "Blog Details"
export const MarkJecnoBlog = "People just dont do it anymore. We have to change that. Sometimes the simplest things are the most profound.";
export const BlogSingles= "Blog Single"
export const SingleBlogHeading="The Harpeth rises in the westernmost part of Rutherford County, just to the east of the community of College Grove in eastern Williamson County. Internet."
export const AddPosts = "Add Post"
export const PostEdits ="Post Edit"
export const Category = "Category"
export const Content = "Content"
export const BlogPostText = `Enter text in the area on the left. For more info, click the ? (help) icon in the menu.`;
export const FAQHeading = "FAQ"
export const QuickQuestions = 'Quick Questions are answered';
export const SearchArticles = 'SearchArticles';
export const LatestUpdates = 'Latest Updates';
export const SeeAll = 'See All';
export const AskQuestion = 'Ask Question';
export const Navigation= "Navigation"
export const AskOurCommunity = 'Ask our community';
export const FeaturedTutorials = 'Featured Tutorials';
export const Latestarticles = 'Latest articles and videos';
export const Knowledgebases= "Knowledgebase"
export const BrowseArticles = 'Browse Articles';
export const knowledgearticl = 'knowledge articles by category';
export const SupportTickets = "Support Ticket"
export const Loss= "Loss"
export const DeleteData = 'Delete Selected Data..!';
export const CardViewHeading = "Card View"
export const JobSearch = "Job Search"
export const JobFilterData= "Job Filter"
export const JobApplyHeading = "Job Apply"
export const JobListHeading = "Job List"
export const JobDetailHeading = "Job Details"
export const LearningListHeading = "Learning List"
export const Learning = "Learning"
export const NewProjectHeading = "New Project"
export const CreateNewProject = "Create New Project"
export const FilterHeading = "Filter";
export const FindJobs = "Find jobs";
export const Fulltime = "Full-time";
export const Contract = "Contract";
export const Parttime = "Part-time";
export const Internship = "Internship";
export const Temporary = "Temporary";
export const Commission = "Commission";
export const LocationHeading = "Location";
export const AllLocations = "All Locations";
export const NewYork = "New York";
export const SanFrancisco = "San Francisco";
export const Washington = "Washington";
export const Seattle = "Seattle";
export const Chicago = "Chicago";
export const AllJobTitle = "All Job Title";
export const JobHeading = "Job"
export const UIUxdesigner = "UI/Ux designer";
export const FindCourse = "Find Course";
export const Categories = "Categories";
export const Accounting = "Accounting";
export const GraphicDesigner = "Graphic designer";
export const Frontenddesigner = "Front end designer";
export const PHPdeveloper = "PHP developer";
export const ReactDeveloper = "React Developer";
export const IndustryHeading = "Industry";
export const AllIndustries = "All Industries";
export const ComputerSoftware = "Computer Software";
export const ITEngineer = "IT Engineer";
export const Serviceindustry = "Service industry";
export const FinancialServices = "Financial Services";
export const Htmlcss = "HTML,scss & sass";
export const Javascript = "Javascript";
export const Nodejs = "Node.js";
export const SpecificSkills = "Specific skills";
export const AllSkills = "All Skills";
export const GulpPug = "Gulp & Pug";
export const Angularjs = "Angular.js";
export const UIDesigner = "UI Designer";
export const Savethisjob = " Save this job";
export const PersonalDetails = "Personal Details";
export const RepeatPassword = "Repeat Password";
export const BirthDate = "Birth Date";
export const CollegeName = "College Name";
export const Period = "Period";
export const DegreeLevel = "Degree Level";
export const Specialization = "Specialization";
export const YourExperience = "Your Experience";
export const YourEducation = "Your Education";
export const UploadCoverLetter = "Upload Cover Letter";
export const UploadYourCV = "Upload Your CV";
export const UploadRecommendations = "Upload Recommendations";
export const UploadYourFiles = "Upload Your Files";
export const CompanyName = "Company Name";
export const ProductDesigner = "Product Designer (UI/UX Designer)"
export const EndlessUnitedStates = "Endless - United States"
export const JobDescription = "Job Description"
export const Share= "Share"
export const Similarjobs ="Similar jobs"
export const BlogHeading = "Blog";
export const Filter= "Filter"
export const Design = "Design";
export const Development = "Development";
export const Management = "Management";
export const Duration = "Duration"
export const AllCourses = "All Courses";
export const PaidCourses = "Paid Courses";
export const FreeCourses = "Free Courses";
export const Registration = "Registration";
export const Completed = "Completed"
export const UIDesign = "UI Design"
export const InterfaceDesign= "Interface Design"
export const UserExperience= "User Experience"
export const UXDesign = "UX Design"
export const FrontendDevelopment = "Frontend Development";
export const BackendDevelopment = "Backend Development";
export const UpcomingCoursesHeading = "Upcoming Courses";
export const UXDevelopment = "UX Development";
export const BusinessAnalyst = "Business Analyst";
export const WebDevelopment = "Web Development";
export const DetailedCourses= "Detailed Course"
export const GoogleMaps = "Google Maps";
export const Polylines= "Polylines"
export const LeafletMap = "Leaflet Maps"

// Editors
export const CkEditors = "Ck Editor"
export const Editor= "Editor"
export const AceEditors = "Ace Editor"
export const InlineEditor= "Inline Editor"
export const MDEEditors= "MDE Editor"
export const FirstExamples= "First Example"
export const Discard= "Discard"
// Ecommerce
export const ProductPages= "Product Page"
export const WomenPinkshirt = "Women Pink shirt."
export const ShareIt = "share it"
export const RateNow= "Rate Now"
export const AddToCart= "Add To Cart"
export const BuyNow= "Buy Now"
export const AddToWishList= "Add To WishList"
export const Brand=  "Brand"
export const ProductLists = "Product List"
export const ProductListHeading = "Individual Column Searching (Text Inputs)";
export const PaymentDetailsHeading = "Payment Details"
export const Creditcards= "Credit Card"
export const Debitcard= "Debit Card"
export const ExpirationDate = "Expiration Date"
export const COD= "COD"
export const EMI = "EMI"
export const NetBankingTitle= "Net Banking"
export const Products= "Product"
export const Filters= "Filters"
export const ProductDetails = "Product Details";
export const AddToCartity = "Add to Cart";
export const ViewDetails = "View Details";
export const Categorys= "Categorys"
export const Colors= "Colors"
export const Apply= "Apply"
export const TotalPrice= "Total Price"
export const ContinueShopping = "Continue Shopping"
export const CartEmpty = "Cart Empty";
export const Checkouts= "Checkout"
export const BillingDetails= "Billing Details"
export const TownCity = "Town/City"
export const StateCountry = "State/Country"
export const CheckPayments= "Check Payments"
export const CashOnDelivery= "Cash On Delivery"
export const PlaceOrder= "Place Order"
export const Subtotal= "Subtotal"
export const Shipping= "Shipping"
export const RecentOrders= "Recent Orders"
export const OrdersHistory = "Orders History"
export const NewOrder= "New Orders"
export const ShippedOrders= "Shipped Orders"
export const CancelledOrders= "Cancelled Orders"
export const Datatableorderhistory = "Datatable order history"
export const Wishlists= "Wishlist"
export const BeComeMember = "Become member"
export const SimplePricingCards = "Simple Pricing Card"

// charts
export const ApexChartHeading = "Apex Chart"
export const BasicAreaChart = "Basic Area Chart";
export const AreaSpalineChart = "Area Spaline Chart";
export const BarChart = "Bar chart";
export const ColumnChart = "Column Chart";
export const BubbleChart = "3d Bubble Chart";
export const SteplineChart = "Stepline Chart";
export const PieChart = "Pie Chart ";
export const DonutChart = "Donut Chart";
export const MixedChart = "Mixed Chart";
export const CandlestickChart = "Candlestick Chart";
export const RadarChart = "Radar Chart";
export const RadialBarChart = "Radial Bar Chart";
export const AreaChart = "Area Chart";
export const BarChart2 = "bar-chart2";
export const BasicBarChart = "Basic bar Chart";
export const GoogleChartHeading = "Google Chart"
export const StackingAreaChart = "Stacking Area Chart";
export const RotatingPieChart = "Rotating A Pie Chart";
export const LineChart2 = "Line Chart-2 Chart";
export const DoughnutChart = "Doughnut Chart";
export const PolarChart = "Polar Chart";
export const BackToHomePage = "BACK TO HOME PAGE";
export const WeAreComingSoon = "WE ARE COMING SOON";
export const CurrentLocation = "Current Location";
export const MarkerMap = "Marker Map";
export const Polygons = "POLYGONS";
export const SliceVisibilityThreshold = "Slice Visibility Threshold";
export const MaterialDesign = "Material Design";
export const ComboChart = "ComboChart";
export const GanttChart = "Gantt Chart";
export const LineChart = "Line Chart";
// Project
export const ProjectListHeading = "Project List"
export const CreateNewProjects = "Create New Project"
export const All = 'All';
export const Doing = "Doing"
export const Done = "Done"
export const Issues = "Issues"
export const Resolved = "Resolved"
export const Comment = "Comment";
export const ProjectCreates = "Project Create"
export const Add= "Add"
export const ProjectTitle = 'Project Title';
export const ClientName = 'Client name';
export const ProjectRate = 'Project Rate';
export const ProgressLevel = 'Progress Level';
export const ProjectStatus = 'Project Status';
export const ProjectSize = 'Project Size';
export const Medium = 'Medium';
export const Big = 'Big';
export const StartingDate = 'Starting date';
export const EnterSomeDetails = 'Enter some Details';
export const UploadProjectFile = 'Upload project file';
export const Apps = "Apps";
export const FileManagerHeading = 'File Manager';
export const FileFilter = 'File filter';
export const AddNew = 'Add New';
export const AllFiles = 'All Files';
export const File = 'Files';
export const Storage = 'Storage';
export const PricingPlan = 'Pricing Plan';
export const Selected = 'Selected';
export const TrialVersion = 'Trial Version';
export const FREE = 'FREE';
export const Premium = 'Premium';
export const QuickAccess= "Quick Access"
export const Folder= "Folders"

// SerachResult
export const SearchWebsite = `Search Website`
export const SearchPages = `Search Pages`
export const Search = "Search"
export const Images = 'Images';
export const Videos = 'Videos';
export const Maps = 'Maps';
export const SearchPixelStrap = `Search result for "Pixelstrap"`
export const MyPortfolioTitle = "My Portfolio";
export const ToDoHeading = "To-Do"
export const ToDofilter= "To Do filter"
export const ToDoList = "To Do List"
export const AddTask= "Add Task"
export const SocialAppHeading = "Social App"
export const MyPage= "My Page"
export const Likes = "Likes";
export const View = "View";
export const NewLikesThisWeek = "New Likes This Week";
export const MyProfile = "My Profile";
export const MutualFriend = "Mutual Friends";
export const ActivityFeed = "Activity Feed";
export const Photo = "Photo";
export const MoreComments = "More Comments";
export const ProfileIntro = "Profile Intro";
export const AboutMe = "About Me";
export const FavouriteTVShows = "Favourite TV shows";
export const FavouriteMusicBands = "Favourite Music Bands ";
export const SocialNetworks = "Social Networks";
export const Facebook = "Facebook";
export const Dribbble = "Dribbble";
export const Followers = "Followers";
export const AddFriend = "Add Friend";
export const LatestPhoto = "Latest Photos";
export const Friends = "Friends";
export const PepoleKnow = "Pepole You May Know";
export const HobbiesAndInterest = "Hobbies and Interests";
export const Hobbies = "Hobbies";
export const FavouriteMusicBandsArtists = "Favourite Music Bands / Artists";
export const FavouriteBooks = "Favourite Books";
export const FavouriteGames = "Favourite Games:";
export const FavouriteMovies = "Favourite Movies";
export const FavouriteWriters = "Favourite Writers:";
export const OtherInterests = "Other Interests:";
export const EducationAndEmploymentHeading = "Education and Employement";
export const TheNewCollegeOfDesign = "The New College of Design";
export const DigitalDesignIntern = "Digital Design Intern";
export const RembrandtInstitute = "Rembrandt Institute";
export const UXUIDesigner = "UI/UX Designer";
export const TheDigitalCollege = "The Digital College";
export const ViewedYourProfile = "Viewed Your Profile";
export const ActivityLogHeading = "Activity Log";
export const Posts = "Posts"

// Calender
export const CalenderHeading = 'Calender Basic';
export const DraggableEvents = "Draggable Events";
export const RemoveAfterDrop = "remove after drop";

// Tasks
export const TasksHeading = "Tasks"
export const TaskFilter= "task filter"
export const Views= "Views"
export const Newsletter = "News letter"
export const Holidays = "Holidays"
export const Business = "Business";
export const Tags = "Tags"
export const Save= "Save"
export const CreatedByMe = "Created By Me"
export const TodayTasks = "Today's Tasks";
export const DelayedTasks = 'Delayed Tasks';
export const UpcomingTasks = 'Upcoming Tasks';
export const ThisWeekTask = 'This week tasks';
export const AssignedToMe = 'Assigned to me';
export const MyTasks = 'My tasks';
export const ThisMonthTasks = 'This month tasks';
export const NoTaskDueToday = 'No task due today.';
export const NoTasksFound = 'No tasks found.';
export const NewTask = 'New Task';
export const AddNewTask = "Add New Task"
export const TaskTitle = 'Task Title';
export const Collection = "Collection";
export const Print= "Print"
export const UserProfiles = "User Profile"
export const Users = "Users"
export const Designer = "Designer"
export const UpdateProfile = "UpdateProfile"
export const PostalCode = "Postal Code"
export const Germany = "Germany"
export const EditProfile = "Edit Profile"
export const UserEdits = "User Edit"
export const AddprojectAndUpload = "Add project And Upload"
export const ProjectName = "Project Name"
export const Edit = "Edit"
export const Update = "Update"
export const UserCards = "User Cards"

// Email
export const Emails = "Email"
export const EmailApps = "Email App"
export const NewMail= "NEW MAIL" 
export const AllMail = 'All mail';
export const Sent = 'Sent';
export const Draft = 'Draft';
export const Trash = 'Trash';
export const TrashList = 'Trash List';
export const IMPORTANT = 'IMPORTANT';
export const Starred = 'Starred';
export const UNREAD = 'UNREAD';
export const Spam = 'Spam';
export const OUTBOX = 'OUTBOX';
export const UPDATE = 'UPDATE';
export const ALERT = 'ALERT';
export const NOTES = 'NOTES';
export const More = 'More';
export const DownloadAll= "Download All"
export const ATTACHMENTS = "ATTACHMENTS"
export const Reply = 'Reply';
export const ReplyAll = 'Reply All';
export const Forward = 'Forward';
export const EmailComposes="Email Compose"
export const NewMessage = "New Message"
export const To= "To"
export const Subject= "Subject"
export const Send= "Send"

// Chat
export const VideoChats= "Video Chat"
export const Chat = "Chat"
export const EndCall = " End Call"
export const Active = "Active";
export const Fax = "Fax";
export const ChatApp = "Chat App"

// Bookmark
export const BookmarkFilter =  "Bookmark Filter"
export const Favourites = 'Favourites';
export const SharedWithMe = 'Shared with me';
export const Important = 'Important';
export const AddBookmark = 'Add Bookmark';
export const EditBookmark = 'Edit Bookmark';
export const MyBookmark = ' My bookmark';
export const Orgenization = 'Organization';
export const NewBookmark = "New Bookmark"
export const WebUrl = 'Web Url';
export const Group = 'Group';
export const Title = "Title"
export const CreateTag= "Create Tag"
export const TagName= "Tag Name"
export const TagColor= "Tag Color"
export const NoBookmarksFound = 'No Bookmarks Found.';

// Contact
export const Contacts=  "Contacts"
export const ContactFilter= "Contact Filter"
export const FollowUp= "Follow Up"
export const Ideas= "Ideas"
export const NewContacts = "New Contacts"
export const AddContacts = "Add Contacts"
export const Mobile= "Mobile"
export const Personal = "Personal"
export const AddCategory= "Add Category"
export const History = "History"
export const MobileNo= "Mobile No"
export const PrintViews= "Print Views"
export const Organization = "Organization"
export const Gender= "Gender"
export const ContactHistory= "Contact History"
export const ContactCreated= "Contact Created"
// Tables
export const ReactstrapBasicTables= "Reactstrap Basic Tables"
export const ReactstrapTables = "Reactstrap Tables"
export const BasicTableWithBorderBottomColor = "Basic Table With Border Bottom Color";
export const InverseTable= "Inverse Table"
export const HoverableRowsWithHorizontalBorder = `Hoverable Rows With Horizontal Border`
export const CaptionSpan = [{text:`A <caption> functions like a heading for a table. It helps users with screen readers to find a table and understand what it’s about and decide if they want to read it.`}]
export const StripedRowWithInverseTable = `Striped Row with Inverse Table`
export const SizeTable = `sizing Table`
export const CustomTable = `Custom Table Color With Hover And Stripped`
export const Id = 'Id';
export const JoinDate = 'Join Date';
export const Office = 'Office';
export const Age = 'Age';
export const Position = 'Position';
export const Salary = 'Salary';
export const Schedule = 'Salary';
export const Security = 'Salary';
export const Status = 'Salary';
export const TeamLead = 'Salary';
export const SignalName = 'Salary';
export const Stage = 'Salary';
export const Budget= "Budget";
export const Sex = 'Sex';
export const EmployeeName = 'Employee Name';
export const Experience = 'Experience';
export const Calories = 'Calories';
export const Quantity = 'Quantity';
export const OrderId = 'OrderId';
export const Assign = 'Assign';
export const Phone = 'Phone';
export const Hours = 'Hours';
export const Performance = 'Performance';
export const DomesticGross = 'DomesticGross';
export const FilmTitle = 'FilmTitle';
export const Released = 'Released';
export const Studio = 'Studio';
export const Spots = 'Spots';
export const Trainer = 'Trainer';
export const Type = 'Type';
export const ClassNames="ClassName"
export const Designation = 'Designation';
export const Company = 'Company';
export const Language = 'Language';
export const InverseTablePrimaryBackground = "Inverse Table Primary Background"
export const Role= "Role"
export const CreditVolume= "Credit Volume"
export const Caption = 'Caption';
export const TableHeadOptions= "Table Head Options"
export const DessertType = 'Dessert Type';
export const Fat = 'Fat';
export const Dessert = 'Dessert';
export const Weigth = 'Weigth';
export const BreckPointSpecific = "Breck Point Specific"
export const DashedBorder= "Dashed Border"
export const Total= "Total"
export const ResponsiveTables= "Responsive Tables With Light Background"
export const Task = "Task";
export const TableComponents = 'Table Components';
export const UIComponents = 'UI Components';
export const ProgressBarHeading = "Progress Bar";
export const Checkbox = "Checkbox";
export const RadioButtons = "Radio Buttons";
export const Select = "Select";
export const Input = "Input";
export const TooltipTriggers = "Tooltip Triggers";
export const Badges= "Badges"
export const Switch= "Switch"
export const DefaultButton = "Default Button"
export const Buttondropdowns = "Button dropdowns"
export const BasicButtongroup = "Basic Button group"
export const ButtonswithIcon = "Buttons with Icon"
export const IconButton = "Icon Button"
export const LoadingButtons = "Loading Buttons"
export const BasicAlert = "Basic Alert"
export const AlertswithLinks = "Alerts with Links"
export const DismissibleAlerts = "Dismissible Alerts"
export const Alertswithicons = "Alerts with icons"
export const DefaultProgress = "Default Progress"
export const StripedProgress = "Striped Progress"
export const ProgressSizes = "Progress Sizes"
export const Checkboxs = "Checkbox"
export const BasicCheckboxs = "Basic Checkbox"
export const DefaultCheckboxSquar = "Default Checkbox Squar"
export const BasicSkinCheck = "Basic Skin Check"
export const DisableCheck = "Disable Check"
export const FlatSkinCheck = "Flat Skin Check"
export const InlineCheckboxs = "Inline  Checkbox"
export const RadioButton = "Radio Button"
export const BasicRadioButton = "Basic Radio Buttons"
export const CheckedRadio = "Checked Radio"
export const Selects= "Select"
export const SingleSelect = "Single Select"
export const DisabledSelectMode = "Disabled Select Mode"
export const LargeSelectModes = "Large Select Mode"
export const Examplemultipleselect = "Example multiple select"
export const DefaultInputtext = "Default Input text"
export const TooltipTrigger = "Tooltip Triggers"
export const Outlinebutton = "outline button"
export const Switchs = "Switch"
export const DefaultSwitch = "Default Switch"
export const UnheckedSwitch = "Unhecked Switch"
export const DisableSwitch = "Disable Switch"
export const SwitchOutline = "Switch Outline"
export const SwitchColor = "Switch Color"
export const BasicInitHeading = "Basic Init"
export const DataTables ="Data Tables"
export const ZeroConfigurationHeading = "Zero Configuration"
export const StateSaving = `State saving`
export const DynamicHeight = `Scroll - vertical, dynamic height`
export const AdvanceInitHeading = "Advance Init"
export const StockResult = `Stock Result`
export const RowCreateCallBackHeading = "Row Create Callback"
export const APIDataTable= "API DataTables"
export const AddRowsHeading = "Add rows"
export const AddNewRow = "Add new row"
export const ChildrenRows = "Child rows (show extra / detailed information)"
export const FullName = "Full name"
export const ExtraInfo = "Extra info"
export const RowsSelectionAndDeletion = "Row Selection And Deletion (Single Row)"
export const DeleteRow = "Delete Row"
export const CustomFilteringSearch = "Custom filtering - range search"
export const MinimumAge = "Minimum age:"
export const MaximumAge = "Maximum age:"
export const DATASourceDataTables = "DATA Source DataTables"
export const HtmlTableTittle = "HTML (DOM) sourced data"
export const AjaxSourcedDataHeading = "Ajax sourced data"
export const JavascriptSourcedDataHeading = "Javascript sourced data"
export const ServerSideProcessingHeading = "Server-side processing"

// Forms
export const FormWizards= "Form Wizard"
export const FormLayouts = "Form Layout"
export const NumberingWizardHeading = "Numbering wizard";
export const Congratulations = "Congratulations ";
export const CongratulationsMessage = "Well done! You have successfully completed. ";
export const AboveInformationCorrect = "All the above information is correct";
export const ConfirmPassword = "Confirm Password";
export const AgreeToTermsAndConditions = "Agree to terms and conditions";
export const Expiration = "Expiration(MM/YY)";
export const CVVNumber = "CVV Number";
export const UploadDocumentation = "Upload Documentation";
export const LinkedIn = "LinkedIn";
export const Github = "Git hub";
export const SelectState = "Select State";
export const GiveFeedback = "Give Feedback";
export const CardHolder= "Card Holder"
export const StudentValidationFormHeading = "Student validation form";
export const ProductDetail = "Product Detail";
export const CurrentCartHeading = "Current Cart";
export const verticalValidationWizardHeading = "Vertical validation wizard";
export const AddProfile = "Add Profile";
export const CreditCard= "Credit Card"
export const ShippingFormHeading = "Shipping form";
export const BillingInformation = "Billing Information ";
export const OrderID = "Order ID";
export const FillFollowingInformation = "Fill up the following information ";
export const OrderConfirmed = "Thank you! Your order is confirmed.";
export const OrderConfirmedDetails = "An email with your orders specifics will be sent to you as order confirmation.";
export const BalanceText = "Example of cuba dashboard balance card.";
export const TextModal = "Example of cuba dashboard profile card.";
export const SocialLinks = " Social Links "
export const Twitter = " Twitter"
export const Previous = " Previous"
export const Next = " Next"
export const NetBanking = " NET BANKING"
export const City= "City"
export const SelectYourBank = " SELECT YOUR BANK"
export const Finish = "Finish"
export const OtpCode = "Your OTP Code here:"
export const ZipCode= "Zip Code"
export const ValidationForms= "Validation Form"
export const FormsControls= "Form Controls"
export const TooltipFormValidationHeading = "Tooltip Form Validation";
export const LastName = "Last name";
export const SubmitForm = "Submit form";
export const StateError = "Please select a valid state.";
export const CityError = "Please provide a valid city.";
export const Zip = "Zip";
export const State = "State";
export const UserName = "Username";
export const Hometxt = "Home";
export const FormControl = "FormControl";
export const ZipError = "Please provide a valid zip.";
export const cityError = "Please provide a valid city.";
export const ValidFeedBack = "Looks good!";
export const TermsAndConditions = "Agree to terms and conditions";
export const CheckThisCheckbox = "Check this checkbox";
export const InvalidFeedBack = "Example invalid feedback text";
export const ToggleThisRadio = "Toggle this radio";
export const OrToggleThisRadio = "Or toggle this other radio";
export const MoreInvalidFeedBack = "More example invalid feedback text";
export const SelectMenu = "Open this select menu";
export const InvalidFile = "Example invalid form file feedback";
export const One = "One";
export const Two = "Two";
export const Three = "Three";
export const FirstNameRequire = "First name is required";
export const Website = "Website";
export const UserNameError = "Please choose a unique and valid username.";
export const BrowserDefaultsHeading = "Browser defaults";
export const EmailAddress = "Email Address";
export const ChooseFile = "Choose file";
export const Visa = "Visa";
export const MasterCard = "MasterCard";
export const PayPal = "Paypal";
export const AgreePolicies = "I agree to the policies";
export const InformationConfirm = "Are you sure above information are true";
export const SelectYourPaymentMethod = "Select your payment method";
export const ValidationFormHeading = "Validation Form";
export const NameError = "Please enter your valid Name";
export const PasswordError = "Please enter your valid password";
export const MaterCard = "MaterCard";
export const FavoritePixelStrapTheme = "Select Your Favorite Pixelstrap theme";
export const InvalidSelectFeedBack = "Invalid select feedback";
export const InvalidFormFileSelected = "Invalid form file selected";
export const InvalidMessageError = "Please enter a message in the textarea.";
export const AgreeConditions = "Agree to terms and conditions";
export const AgreeFeedback = "You must agree before submitting.";
export const BaseInputs = "Base Inputs"
export const BasicFormHeading = "Basic form";
export const Upgrade = "Upgrade"
export const FloatingFormHeading = "Floating Form";
export const SelectSizingHeading = "Select Sizing";
export const CheckMeOut = "Check me out";
export const SignIn = "Sign in";
export const FormControlSizingHeading = "Form Control Sizing";
export const FileInputHeading = "File Input";
export const DefaultExample = "Default file input example";
export const MultipleExample = "Multiple files input example";
export const DisabledExample = "Disabled file input example";
export const SmallFileInputExample = "Small file input example";
export const LargeFileInputExample = "Large file input example";
export const FlatInputStyleHeading = "Flat Input Style";
export const MultiplePaintingsLabel = "Select your multiple paintings";
export const PleaseDoComments = "Please do comments";
export const BasicHTMLInputControlHeading = "Basic HTML Input Control";
export const PlaceHolderHeading = "Placeholder ";
export const ColorPickerHeading = "Color picker";
export const DataListExampleHeading = "Datalist example";
export const DateHeading = "Date";
export const DateAndTimeHeading = "Date and time";
export const CommentsHeading = "Comments";
export const URLHeading = "URL";
export const MaximumLengthHeading = "Maximum Length";
export const MonthHeading = "Month";
export const NumberHeading = "Number";
export const PasswordHeading = "Password";
export const TelephoneHeading = "Telephone";
export const TimeHeading = "Time";
export const OpenThisSelectMenu = "Open This Select Menu";
export const WeekHeading = "Week";
export const LayoutHeading = "Layout";
export const EmailHeading = "Email";
export const InputGroupHeading = "Input group";
export const BasicFloatingInputControlHeading = "Basic floating input control";
export const ValidInputHeading = "Valid Input";
export const InputWithValue = "Input with value";
export const EdgesInputStyleHeading = "Edges input style";
export const FileInputExample = "Default file input example";
export const DefaultInput = "Default Input";
export const Male = "Male";
export const Female = "Female";
export const Comments = "Comments";
export const RaiseInputStyleHeading = "Raise input style";
export const SelectTheColorHeading = "Select the color you like below";
export const DefaultCheckBoxHeading = "Default CheckBox";
export const DefaultChecksHeading = "Default Checks";
export const DefaultCheckBox = "Default checkbox";
export const CheckedCheckBox = "Checked checkbox";
export const InvalidInputHeading = "Invalid input";
export const WorksWithSelects = "Works with selects";
export const RadioCheckBoxHeading = "Checkbox & Radio";
export const InputGroupsHeading = "Input Groups";
export const MegaOptionHeading = "Mega Option";
export const DatePickerHeading = "Date Picker";
export const FormControlsHeading = "Forms Controls";
export const InputMasksHeading = "Input Masks";
export const FormWizardHeading = "Form Wizard";
export const FormWizard2Heading = "Form Wizard 2";
export const FormLayoutHeading = "Form Layout";
export const TwoFactorHeading = "Two Factor";
export const ClipBoardHeading = "Clip Board";
export const FormWidgetsHeading = "Form Widgets";
export const TouchSpinHeading = "Touch Spin";
export const DateTimePickerHeading = "Date Time Picker";
export const Select2Heading = "Select 2";
export const SwitchHeading = "Switch";
export const TimePickerHeading = "Time Picker";
export const LeafletWorldMap = 'Leaflet WORLD MAP';
export const DisabledChecksHeading = "Disabled Checks";
export const DisabledCheckBox = "Disabled checkbox";
export const InlineInputTypesHeading = "Inline input-types";
export const InlineCheckBoxHeading = "Inline Checkbox";
export const InlineRadiosBoxHeading = "Inline Radios";
export const InlineSwitchesHeading = "Inline Switches";
export const AnimatedButtonsHeading = "Animated buttons";
export const SelectPaymentMethod = "Select your payment method";
export const YourFavoriteSocialMedia = "What is your favorite social media? ";
export const BasicRadioAndCheckBox = "Basic radio and checkbox";
export const SimpleCheckBox = "Simple Checkbox";
export const SimpleRadiosHeading = "Simple Radios";
export const RadioToggleButtonsHeading = "Radio toggle buttons";
export const PaymentMethod = "Payment Method";
export const Address= "Address"
export const Country= "Country"
export const Remembermefornexttime= "Remember me for next time"
export const OtherNotes= "Other Notes"
export const ProceedtoNext= "Proceed to Next"
export const ShippingMethod = "Shipping Method"
export const ShippingInformation = "Shipping Information"
export const SavedAddress = "Saved Address"
export const ShippingInformationText = " Fill up the following information to send you the order"
export const Information= "Information"
export const AddressType= "Address Type"
export const ContactNo= "Contact No"
export const PaymentInformation = "Payment Information"
export const PaymentInformationText = "Fill up the following information to send you the order"
export const CashOnDeliveryHeading = "Cash On Delivery"
export const PortfolioURL= "Portfolio URL"
export const ProjectDescription = "Project Description"
export const TwoFactors = "Two Factor"
export const TwoFactorAuthenticationHeading = "Two-factor authentication";
export const FactorAuthentication = "2 factor authentication"
export const ScanQRcode= "Scan QR code"
export const EmailVerificationHeading= "Email Verification"
export const VerificationCodeHeading= "Verification Code"
export const Resend = "Resend"
export const Call = "Call"
export const NotReceivedCode = "Not Received your Code?"
export const Continue= "Continue"
export const AadhaarNumber ="Aadhaar Number"
export const PAN= "PAN"
export const ChooseBanks = "Choose from these popular banks"
export const SuccessfullyCompleted = "Successfully Completed"
export const Customhorizontalwizard = "Custom horizontal wizard"
export const Businessverticalwizard= "Business vertical wizard"
export const AccountType = "Select the type of account"
export const SearchYour = "Search your"
export const AccountName= "Account Name"
export const SelectTeamWith = "Select team size with"
export const Projects = "projects"
export const ContactDetails = "Contact details"
export const OrganizationName = "Organization Name"
export const JoinOrganizationType = "Join organization type"
export const OrganizationDescription = "Organization description"
export const Customverticalwizard = "Custom vertical wizard"
export const Businesshorizontalwizard= "Business horizontal wizard"
export const DisabledCheckedCheckBox = `Disabled Checked CheckBox`
export const RightChecks = `Right Checks`
export const IndeterminateCheckBox = `Indeterminate CheckBox`
export const IndeterminateHeading = `Indeterminate`
export const CustomCheckBoxHeading = `Custom CheckBox`
export const BorderedCheckBoxHeading = `Bordered CheckBox`
export const DisabledReverseCheckBox = `Disabled Reverse CheckBox`
export const ReverseCheckBox = `Reverse CheckBox`
export const IconCheckBoxHeading = `Icon CheckBox`
export const FilledCheckBoxHeading = `Filled Checkbox`
export const DefaultRadioHeading = `Default Radio`
export const CustomRadiosHeading = "Custom Radios"
export const DefaultCheckedRadio = "Default Checked Radio"
export const DefaultRadio = "Default Radio"
export const DisabledCheckedRadio = "Disabled Checked Radio"
export const DisabledRadio = "Disabled Radio"
export const DisabledRadiosHeading = "Disabled Radios"
export const RightRadiosHeading = "Right Radios"
export const ImagesWithCheckBoxHeading = "Images With CheckBox"
export const ImagesWithRadioBoxHeading = "Images With RadioBox"
export const CustomRadioBoxHeading = "Custom RadioBox"
export const DefaultSwitchesBoxHeading = "Default Switches Box"
export const CheckedSwitchCheckboxInput = "CheckedSwitch Checkbox Input"
export const CustomSwitches = "Custom Switches"
export const DefaultSwitchCheckboxInput = "Default Switch CheckboxInput"
export const DisabledCheckedSwitchCheckboxInput = "Disabled Checked Switch Checkbox Input"
export const DisabledSwitchCheckboxInput = "Disabled Switch CheckboxInput"
export const DisabledSwitches = "Disabled Switches"
export const BorderedRadioBoxHeading= "Bordered Radio"
export const IconRadioBoxHeading= "Icon Radio"
export const FilledRadioBoxHeading= "Filled Radio"
export const RightSwitchesHeading= "Right Switches"
export const Reverseswitchcheckboxinput = "Reverse switch checkbox input"
export const Disabledswitchcheckboxinput = "Disabled switch checkbox input"
export const OutlinedCheckBoxStylesHeading = "Outlined CheckBox Styles"
export const ButtonAddonsHeading= "Button Addons"
export const CustomFormsHeading = "Custom Forms"
export const CustomFileInputHeading= "Custom File Input"
export const Upload= "Upload"
export const Verify= "Verify"
export const ButtonsWithDropDownsHeading= "Buttons With DropDowns"
export const DropdownHeading = "Dropdown";
export const CheckboxesAndRadiosHeading = "Checkboxes and radios";
export const Info = "Info";
export const Secondary = "Secondary";
export const SizingHeader = "Sizing";
export const Small = "Small";
export const Large = "Large";
export const FirstAndLastName = "First and last name";
export const DollarSign = "$";
export const ZeroAmount = "0.00";
export const BasicInputGroupsHeading = "Basic input groups";
export const VariationOfAddonsHeading = "Variation of addons";
export const RecipientUserName = "@example.com";
export const BasicHeader = "Basic";
export const WithTextArea = "With textarea";
export const WrappingHeading = "Wrapping";
export const SegmentedButtonsHeading= "Segmented Buttons"
export const ToggleDropdown= "Toggle Dropdown"
export const MultipleInputsHeading ="Multiple Inputs"
export const LeftAddon = `Left Addon`;
export const RightAddon = `Right Addon`;
export const JointAddon = `Joint Addon`;
export const LeftAndRightAddon = `Left & Right Addon`;
export const SolidStyle = `Solid style`;
export const FlatStyle = `Flat style`;
export const RaiseStyle = `Raise style`;
export const DefaultStyleHeading = `Default style`;
export const EdgeButtons = `Edge Buttons`;
export const RaisedButtons = `Raised Buttons`;
export const FlatStyleHeading = `Flat style`;
export const InputMasks= "Input Mask"
export const DefaultInputMask = "Default Input Mask";
export const Currency = "Currency";
export const Prefix = "Prefix";
export const Delimiter = "Delimiter";
export const PhoneNumber = "Phone Number";
export const CardNumber = "Card Number";
export const Tailprefix = "Tail prefix";
export const DateFormatHeading = "Date Format";
export const Date= "Date"
export const DateFormatType = "Date format type";
export const TimeFormatHeading = "Time Format";
export const TimeFormatType = "Time format type";
export const HourMonthType = "Hour/month type";
export const MegaOption = "Mega Options"
export const VariationRadioHeading = `Variation radio`;
export const MostImportantThingsToLearnAboutWebDesign = "What are the most important things to learn about web design?";
export const RadiosWithCreativeOptionsSVGIcons = "Radios With Creative Options & SVG Icons";
export const WhichActivitiesDoYouEnjoy = "Which of the following activities do you enjoy doing in your free time?";
export const VariationCheckBoxHeading = "Variation checkbox ";
export const ItIsTimeTo = "It's time to";
export const Sales = " Sales";
export const INR= "INR"
export const WithoutBordersStyleHeading= "Without Borders Style"
export const SolidBorderStyleHeading = "Solid Border Style"
export const offerStyleBorderHeading=  "offer Style Border"
export const InlineStyleHeading  = "Inline Style"
export const VerticalStyleHeading= "Vertical Style"
export const DeliveryOptionHeading = "Delivery Option"
export const BuyingOptionHeading= "Buying Option"
export const StartRatingHeading = "start rating";
export const HorizontalStyleHeading = "Horizontal Style"
export const MovieRatingBar = "Movie Rating Bar"
export const SquareRatingBar= "Square Rating Bar"
export const PillRatingBar= "Pill Rating Bar"
export const HalfStarRatingBar= "Half Star Rating Bar"
export const HeartRatingBar= "Heart Rating Bar"

// form widgets
export const Datepickers = "Datepicker"
export const LeafletUkMap = 'Leaflet UK MAP';
export const LeafletUSAMap = 'Leaflet USA MAP';
export const LeafletIndiaMap = 'Leaflet India MAP';
export const LeafletAustraliaMap = 'Leaflet Australia MAP';
export const JavascriptModeHeading = "Javascript Mode";
export const HTMLModeHeading = "HTML Mode";
export const CSSModeHeading = "CSS Mode";
export const JavaModeHeading = "Java Mode";
export const DefaultCalendarHeading = "Default calendar";
export const ReactstrapCalendarHeading = "Reactstrap calendar";
export const Month = "Month";
export const Week = "Week";
export const Time = "Time";
export const DefaultDate = "Default Date";
export const HumanFriendly = "Human Friendly";
export const MinMaxValue = "Min-Max Value";
export const DisabledDates = "Disabled Dates";
export const MultiplesDatesHeading = "Multiples Dates";
export const Range = "Range";
export const PreloadingDates = "Preloading Dates";
export const hourPicker = "24-hour Time Picker";
export const TimePickerLimit = "Time Picker W/Limits";
export const PreloadingTimes = "Preloading Time";
export const CustomizingConjunctions = "Customizing Conjunction"
export const TimePickerRange = "TimePicker with Limited Time Range";
export const TimePickerMinMaxRanges = "TimePicker with Min/Max Time Range";
export const DateWithTimes ="Date With Time"
export const DefaultTouchSpinHeading = "Default Touchspin";
export const OutLinedTouchSpinHeading = "Outlined TouchSpin";
export const RoundedTouchSpinHeading = "Rounded TouchSpin";
export const IconsWithPrefixAndPostFixHeading = "Icons with prefix and postfix";
export const ButtonsWithPrefixAndPostFixHeading = "Buttons with prefix and postfix";
export const Pre = "Pre";
export const Post = "Post";
export const CustomSwitchHeading = "Custom switch";
export const IconsWithHeading = "Icons switch";
export const UncheckedSwitchHeading = "Unchecked switch";
export const BordersWithIconsHeading = "Borders With Icons";
export const MdeEditorExample = "MDE Editor Example";
export const MdeEditorText = `Enter text in the area on the left. For more info, click the ? (help) icon in the menu.`;
export const Instructions = "Instructions";
export const MNDeditortext = "Enter text in the area on the left. For more info, click the ? (help) icon in the menu.";
export const Profit = "Profit";
export const Delete = "Delete";
export const BasicDemo = "Basic Demo";
export const SwitchSizingHeading = "Switch Sizing";
export const SwitchWithIconsHeading = "Switch With Icons";
export const TypeAheadHeading = "Typahead";
export const BasicTypeAheadHeading = "Basic typeahead"
export const BloodHoundHeading = "Blood Hound"
export const CustomTemplate = "Custom templates"
export const MultipleSectionWithHeader = "Multiple sections with headers"
export const RemotetypeAheadHeading = "Remote typeahead"
export const PreFetchHeading = "Prefetch"
export const ScrollableDropDownMenus = "Scrollable DropDown Menu"
export const RTLSupports = "RTL Support"
export const Copy = "Copy";
export const ClipBoardOnTextInputHeading = "Clipboard on text input";
export const Cut = "Cut";
export const ClipBoardOnTextArea = "Clipboard on textarea";
export const CutCopyFromInputArea = "Cut/copy from text input";
export const CopyParagraph = "Copy portion from paragraph";
export const ClipboardOnTextAreaValue = "A web designer must always enhance their work since creating websites is a creative effort. Therefore, a web designer must be more imaginative to produce exceptional results. Blogs about web design assist web designers in learning about new technologies, offer lessons, news, direction for a freebie, and much more. These blogs allow web designers to stay creative and improve their abilities. Therefore, advice from web design blogs is required to improve your business."
export const ClipboardOnParagraphHeading = "Clipboard on paragraph";
export const ClipboardOnParagraphValue = "On that day, hopes and dreams were crushed. Even though it should have been anticipated, it nonetheless surprised me. The warning indicators have been disregarded in favour of the slim chance that it would actually occur. From a hopeful prospect, it had evolved into an unquestionable conviction that it must be fate. That was up until it wasn't, at which point all of the aspirations and dreams collapsed.";
export const CopyTextParagraph = "that are visible online. Take a website design course to learn how to  create an appealing and responsive website. In the discipline of web design, there are degree, diploma, postgraduate degree, and certificate programmes. A web designer is responsible for a website's look, feel, and occasionally even content."
export const  CopyHighlighted = " Copy highlighted text"
export const DisabledOutlineSwitchHeading = "Disabled outline switch";
export const VariationOfSwitchesHeading = "Variation of switches";
export const Skewed = " Skewed";
// Buttons
export const DefaultStyles = "Default Style"
export const Buttons ="Button"
export const DefaultButtonsHeading = "Default Buttons";
export const LargeButtonsHeading = "Large Buttons";
export const SmallButtonsHeading = "Small Buttons";
export const ExtraSmallButtonsHeading = "Extra Small Buttons";
export const ActiveButtonsHeading = "Active Buttons";
export const DisabledButtonsHeading = "Disabled Buttons";
export const CustomStateButtonsHeading = "Custom State Buttons";
export const OutlineButtonsHeading = "Outline Buttons";
export const BoldBorderOutlineButtonsHeading = "Bold Border Outline Buttons";
export const OutlineLargeButtonsHeading = "Outline Large Buttons";
export const OutlineSmallButtonsHeading = "Outline Small Buttons";
export const OutlineExtraSmallButtonsHeading = "Outline Extra Small Buttons";
export const DisabledOutlineButtonsHeading = "Disabled Outline Buttons";
export const GradientButtonsHeading = "Gradient Buttons";
export const defaultButtonsHeadingData = "Bootstrap state buttons"
export const LargeButtonsHeadingData = `Add <code>.btn-lg</code> class for large size buttons`
export const SmallButtonsHeadingData = `Add <code>.btn-sm</code> class for small size buttons`
export const ExtraSmallButtonsHeadingData = `Add <code>.btn-xs</code> class for extra small size buttons`
export const ActiveButtonsHeadingData = `Add <code>.active</code> class for active state`
export const DisabledButtonsHeadingData = `Add <code>.disabled</code> class or <code>disabled="disabled"</code> attribute for disabled button`
export const CustomStateButtonsHeadingData = `The <code>.btn</code> class used with <code>&lt;button&gt;</code>, <code>&lt;a&gt;</code> and <code>&lt;input&gt;</code> elements.`
export const OutlineButtonsHeadingData = `Add <code>.btn-outline-*</code> class for border button`
export const BoldBorderOutlineButtonsHeadingData = `Add <code>.btn-outline-*-2x</code> class for bold outline`
export const OutlineLargeButtonsHeadingData = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-lg</code> class for large button`
export const OutlineSmallButtonsHeadingData = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-sm</code> class for small button`
export const OutlineExtraSmallButtonsHeadingData = `Add <code>.btn-outline-*</code> class for outline and <code>.btn-xs</code> class for extra small button`
export const DisabledOutlineButtonsHeadingData = `Add <code>.disabled</code> class or <code>disabled="disabled"</code> attribute for disabled state`
export const GraddienButtonsHeadingData = `Add <code>.btn-*-gradien</code> class for gradien button`
export const Links= "Link"
export const CustomButtons = "Custom state buttons"
export const ButtonHeading = "Button"
export const CustomButtonsSpan = `The <code>.btn</code> class used with <code>&lt;button&gt;</code>, <code>&lt;a&gt;</code> and <code>&lt;input&gt;</code> elements.`
export const NestingButtonSpan = `Make nesting buttons`
export const Inputs = "Input"
export const Submit= "Submit"
export const FlatButton = "Flat Buttons"
export const EdgeButton= "Edge Buttons"
export const RaisedButton= "Raised Buttons"
export const ButtonGroups= "Button Group"
export const RadioButtonGroup= "Radio Button Group"
export const CheckBoxButtonGroup= "CheckBox Button Group"
export const Option1 = 'Option 1';
export const Option2 = 'Option 2';
export const Nesting = 'Nesting';
export const Action = 'Action';
export const AnotherAction = 'Another Action';
export const Header = 'Header';
export const Vertical = 'Vertical';
// icons
export const FlagIcon = "Flag Icons"
export const Icons= "Icons"
export const Markup= "Markup"
export const CopyText= "Copy Text"
export const FontAwesomeIcon= "Font Awesome Icon"
export const ICOIcons= "ICO Icon"
export const ThemifyIcons= "Themify Icon"
export const FeatherIcon= "Feather Icon"
export const WhetherIcons = "Whether Icon"
export const WhetherIconsWithAnimations= "Whether Icons With Animations"
export const List= "Lists"
export const Contextualclasses= "Contextual classes"
export const Horizontallists= "Horizontal lists"
export const Customcontentlists= "Custom content lists"
export const Listswithcheckboxs= "Lists with checkbox"
export const AutoStart= "Auto Start"
export const Listswithradios= "Lists with radios"
export const Meditations= "Meditations"
export const Listswithnumbers = "Lists with numbers"
export const Numberedbadgelists= "Numbered & badge lists"
export const Disabledlists= "Disabled lists"
export const Scrollablelists= "Scrollable lists"
export const JavaScriptbehavior = "JavaScript behavior"
export const Product= "Product"
export const Productdetails= "Product details"
export const Pricing = "Pricing"
export const Paymentdetails= "Payment details"
export const Megaoptions = "Mega options"
export const YourBalances= "Your Balances"
export const Visitor= "Visitor"
export const TotalUser= "Total User"
export const FollowersGrowths  = "Followers Growths"
export const Generals = "General";
export const Widgets= "Widgets"

// PageLayout
export const DarkFooter = "Dark Footer"
export const PageLayout= "Page Layout"
export const SampleCard= "Sample Card"
export const FixedFooter= "Fixed Footer"
export const OnScrollHideMenu= "Hide Menu On Scroll"

// Login
export const SignInAccount = "Sign in to account"
export const RememberPassword = "Remember password"
export const ForgotPassword = "Forgot password?"
export const SignInWith = "Or Sign In With"
export const FacebookHeading = "facebook"
export const TwitterHeading = "twitter"
export const LinkedInHeading = "LinkedIn"
export const DoNotAccount = "Don't have account?"
export const CreateAccount = "Create Account"
// ThemeCustomizer
export const CheckLayouts = "Check layouts";
export const Quickoption = "Quick option";
export const PREVIEWSETTINGS = "PREVIEW SETTINGS";
export const Layout_Type = "Layout Type";
export const Sidebar_Icon = "Sidebar Icon";
export const UnlimitedColor = "Unlimited Color";
export const Mix_Layout = "MixLayout";
export const Sidebar_Type = 'Sidebar Type';
// Error
export const CreateYourAccount = "Create your account"
export const EnterYourPersonalDetails = "Enter your personal details to create account"
export const YourName = "Your Name"
export const PrivacyPolicy = "Privacy Policy"
export const AgreeWith = "Agree with"
export const SignUpWith = "Or signup with"
export const HaveAccount = "Already have an account?"
export const Unlock = "Unlock"
export const EnterYourPassword = "Enter your Password"
export const ResetYourPassword = "Reset Your Password"
export const EnterYourMobileNumber = "Enter Your Mobile Number"
export const SignUpToAccount = `Sign Up To Account`
export const EmailPassWord = `Enter your email & password to login`
export const HavePassport =  "Have Passport"
export const Birthday= "Birthday"
export const RetypePassword = "Retype Password"
export const EnterOTP = "Enter OTP"
export const CreateYourPassword = "Create Your Password"
export const NewPassword = "New Password"
export const MAINTENANCE = `MAINTENANCE`
export const Education = "Education";
export const Employment = "Employment";
export const Criminal = "Criminal";
export const Identity = "Identity";
export const Reference = "Reference";
export const DrugTest = "Drug";
export const CreditCheck = "CreditCheck";
export const PoliceVerification = "PoliceVerification";
export const VerificationDetails = "Verification Details";

export const educationColumns = ["Education Details", VerificationDetails];
export const employmentColumns = ["Employment Details", VerificationDetails];
export const addressColumns = ["Address Details", VerificationDetails];
export const criminalColumns = ["Criminal Details", VerificationDetails];
export const identityColumns = ["Identity Details", VerificationDetails];
export const referenceColumns = ["Reference Details", VerificationDetails];
export const drugTestColumns = ["Drug Test Details", VerificationDetails];
export const creditCheckColumns = ["Credit Check Details", VerificationDetails];
export const policeColumns = ["Police Details", VerificationDetails];

export const adsumLogoImage =
  "data:image/jpeg;base64,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";
export const stampLogoImage =
  "data:image/jpeg;base64,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";
export const cyptoKey = "verification id"